<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <span class="text-info" role="button" @click="menuBreadcrumb(0)"
                >Home</span
              >
            </li>
            <li
              v-show="tela == 1"
              class="breadcrumb-item active"
              aria-current="page"
            >
              Tratamento de Ponto
            </li>
            <li
              v-show="tela == 2"
              @click="menuBreadcrumb(1)"
              class="breadcrumb-item"
            >
              <span class="text-info" role="button">Tratamento de Ponto</span>
            </li>
            <li
              v-show="tela == 2"
              class="breadcrumb-item active"
              aria-current="page"
            >
              Cartão de Ponto
            </li>
          </ol>
        </nav>

        <!-- TELA DE FILTRO-->
        <card card-body-classes="table-full-width" v-show="tela == 1">
          <h4 slot="header" class="card-title text-left">
            TRATAMENTO DO PONTO
          </h4>
          <div class="row pl-4 pr-4">
            <BaseFiltroPonto
              class="col-sm-6 col-12"
              @imprimir="imprimir"
              @pesquisar="pesquisar"
              @enviarEmail="enviarSolicitacaoEmail"
              :periodo="periodo"
              :btEnviarEmail="true"
            />
            <div class="offset-sm-6 "></div>
          </div>
        </card>
        <!-- TELA DE RESULTADO-->
        <card
          card-body-classes="table-full-width"
          v-show="tela == 2"
          id="imprimirFolha"
        >
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="col-6 offset-6 d-flex justify-content-end hidden-print">
              <base-button
                v-show="!printing"
                type="info"
                class="animation-on-hover"
                @click="imprimirFolha()"
                simple
              >
                <i class="tim-icons icon-paper"></i> Imprimir
              </base-button>
            </div>
          </div>

          <BaseCartaoPonto
            v-if="dados.length && dados[0].config.layoutAjustePonto == 1"
            v-for="item in dados"
            :key="
              item.dadosEmpregado.cpf + (item.dadosEmpregado.matricula || '')
            "
            class="break"
            :dados="item"
            :periodo="periodo"
            :printing="printing"
            :modoVisualizacao="false"
            :showBtAbono="showAbonos"
            @atualizarTable="atualizarTable"
          >
          </BaseCartaoPonto>

          <BaseCartaoPontoSemsa
            v-if="dados.length && dados[0].config.layoutAjustePonto == 2"
            v-for="item in dados"
            :key="
              item.dadosEmpregado.cpf + (item.dadosEmpregado.matricula || '')
            "
            class="break"
            :dados="item"
            :periodo="periodo"
            :printing="printing"
            @atualizarTable="atualizarTable"
          >
          </BaseCartaoPontoSemsa>

          <Paginacao
            v-show="!printing"
            :currentPage="pagination.currentPage"
            :totalPages="pagination.totalPages"
            @page-changed="carregarCartaoDePonto"
          />
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Card,
  BaseInput,
  BaseFiltroPonto,
  BaseCartaoPonto,
  BaseCartaoPontoSemsa,
  Paginacao,
} from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseInput,
    BaseFiltroPonto,
    BaseCartaoPonto,
    BaseCartaoPontoSemsa,
    Paginacao,
  },
  computed: {},
  data() {
    return {
      showAbonos: false,
      dadosUsuario: "",
      pagination: {
        currentPage: 1,
        perPage: 10,
        totalItems: 0,
        totalPages: 0,
      },
      payloadPesquisa: Object,
      printing: false,
      periodo: {
        de: "",
        ate: "",
      },
      isLoading: false,
      dados: [],
      tela: 1, //1-pesquisar, 2-resultados
    };
  },
  mounted() {
    this.carregarDadosUsuario();
  },
  methods: {
    enviarSolicitacaoEmail(payload) {
      let th = this;
      th.isLoading = true;
      this.axios
        .post("/api/solicitarTodosCartaoDePonto", payload)
        .then((response) => {
          th.isLoading = false;
          if (response.data.status) {
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Solicitação enviada com sucesso! Os dados serão enviados para o(s) email(s) inserido(s)",
              "success",
            );
            setTimeout(() => {
              location.reload();
            }, 3000);
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao solicitar cartão de ponto!",
              "error",
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao solicitar cartão de ponto!",
            "error",
          );
        });
    },
    menuBreadcrumb(menu) {
      switch (menu) {
        case 0:
          this.$router.push("/home");
          break;
        case 1:
          this.payloadPesquisa = {};
          this.tela = 1;
          this.dados = [];
          break;
      }
    },
    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    atualizarTable() {
      this.carregarCartaoDePonto(this.pagination.currentPage); // teve alguma request e precisou atualizar. Ex: batida manual
    },
    pesquisar(event) {
      this.payloadPesquisa = event; //salva esse payload para usar caso precise atualizar a tabela depois de uma operacao
      this.periodo.de = this.payloadPesquisa.data_inicial;
      this.periodo.ate = this.payloadPesquisa.data_final;
      this.carregarCartaoDePonto(1); // emitido pelo botao pesquisar
    },
    imprimir(event) {
      console.log("Clicou em imprimir");
      console.log(event);
      console.log("-------------------");
    },
    carregarCartaoDePonto(page = 1) {
      const th = this;
      const bodyFormData = {
        ...this.payloadPesquisa,
        page,
        limit: this.pagination.perPage,
      };
      this.isLoading = true;
      this.axios
        .post("/api/listarCartaoDePonto", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.status == "success") {
            th.dados = response.data.data.funcionarios;
            th.pagination = response.data.data.paginacao;
            th.tela = 2;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao carregar cartão de ponto!",
              "error",
            );
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar cartão de ponto!",
            "error",
          );
        });
    },
    carregarDadosUsuario() {
      this.dadosUsuario = this.$cookies.get("usuario") || null;
      //se for usuario entao carrega os dados de permissao
      if (this.dadosUsuario) {
        this.carregarPermissoesUsuario();
      } else {
        // adm
        this.showAbonos = true;
      }
    },
    carregarPermissoesUsuario() {
      const PATH_ABONOS = "/pesquisarAbonos";

      const paths = [PATH_ABONOS];

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: this.dadosUsuario.id,
        paths,
      };

      this.isLoading = true;

      this.axios
        .post("/api/usuarios/listarPermissoes", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          this.isLoading = false;

          if (response.data.status == "success") {
            this.showAbonos = response.data.data.some(
              (item) => item.path === PATH_ABONOS,
            );
          } else {
            this.showSwal(
              "auto-close",
              "Erro",
              "Erro ao carregar Permissões de Usuário",
              "error",
            );
          }
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar Permissões de Usuário",
            "error",
          );
        });
    },
  },
  watch: {},
};
</script>
<style>
.break {
  page-break-before: always;
}
</style>
